<template>
    <div class="Sidebar shadow" v-bind:class="{ 'is-close': closeSidebar}">
        <div class="Sidebar-button " v-bind:style="{paddingTop: `8px`}"
             @click="toggleSidebar()">
            <i class="fi flaticon-menu"></i>
        </div>
        
        <div class="Sidebar-user"
             v-bind:style="{backgroundColor : `$primary`}">
            
            <div class="text-truncate text-uppercase">{{currentUser.name}} {{currentUser.surname}}</div>
            <div class="small text-uppercase text-truncate" v-if="currentUser.role === 'society' ">
                {{currentUser.data.society}}
            </div>
            <div class="small">{{currentUser.role}}</div>
        </div>
        <img :src="getLogo" class="Sidebar-logo" alt="logo"/>

        <ul class="Sidebar-menuContainer">
        
            <li v-for="(item,index) in menuItems" v-bind:key="index"
                v-on:click.prevent="openPage(item.route)"
                v-bind:class="(item.route === $route.name) ? 'active' : ''"
                class="Sidebar-menu">
                <div class="Sidebar-menu-label mr-auto">
                    {{item.label}}
                </div>
                <div class="Sidebar-icon">
                    <i class="fi" v-bind:class="'flaticon-' + item.icon"></i>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 100 100" preserveAspectRatio="none">
                        <polygon points="0,100 100,0 100,100"/>
                    </svg>
                </div>
            </li>
            <li class="Sidebar-menu" v-on:click="logout">
                <div class="Sidebar-menu-label mr-auto">
                    {{labelLogout}}
                </div>
                <div class="Sidebar-icon">
                    <i class="fi flaticon-logout"></i>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 100 100" preserveAspectRatio="none">
                        <polygon points="0,100 100,0 100,100"/>
                    </svg>
                </div>
            </li>
        </ul>

    </div>
</template>

<script>

    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import menuItemsAdmin from "./menuItemsAdmin";
    import menuItemsSociety from "./menuItemsSociety";

    export default {
        name: "Sidebar",
        data() {
            return {}
        },
        computed: {

            ...mapGetters([
                'currentUser',
                'closeSidebar',
                'isImpersonating'
            ]),

            getLogo() {
                return require('@/assets/media/logo.svg');
            },
            labelLogout() {
                return this.isImpersonating ? 'Torna Admin' : 'Logout';
            },
            menuItems() {
                return this.currentUser.role === 'admin' ? menuItemsAdmin : menuItemsSociety;
            }

        },

        methods: {

            ...mapMutations([
                'authLeaveImpersonate',
            ]),

            ...mapActions({
                toggleSidebar: 'toggleSidebar',
                authLogout: 'authLogout',
                authCurrentUser: 'authCurrentUser',
                authRefreshToken: 'authRefreshToken',
            }),

            logout: function () {
                if (this.isImpersonating) {
                    this.authLeaveImpersonate();
                    this.authRefreshToken()
                        .then(() => {
                            this.authCurrentUser()
                                .then(() => {
                                    this.$router.push({name: 'admin.societies.list'});
                                    this.$bvToast.toast('Impersonate abbandonato', {
                                        title: 'Success',
                                        variant: 'success'
                                    });
                                }).catch(() => {
                                this.authLogout()
                                    .then()
                                    .catch();
                            });
                        }).catch(() => {
                        this.authLogout()
                            .then()
                            .catch();
                    });

                } else {
                    this.authLogout()
                        .then()
                        .catch();
                }

            },

            openPage: function (route) {

                if (route !== '' && route !== this.$route.name) {
                    if (this.$mq !== 'lg') {
                        this.toggleSidebar();
                    }
                    this.$router.push({name: route})
                } else {
                    window.location.reload();
                }

            }
        },
    }
</script>

<style scoped>

</style>
